import React from "react";
import ReactECharts from "echarts-for-react";
import moment from "moment";
import close from "./minimise_button.png";

class GradientChart extends React.Component {
  constructor(props) {
    super(props);

    const { minimumDate, maximumDate, xAxisTitle, yAxisTitle, title, seriesData, toggleVisibleGraphPanel } = props;

    this.state = {
      options: {
        title: {
          text: title,
          left: "center",
          top: 8,
          textStyle: {
            fontSize: 14,
            fontWeight: "bold",
            color: "#000",
          },
        },
       

        tooltip: title.includes("Standardized Runoff Index")  ? {
          trigger: "axis",
          formatter: (params) => {
            const { data } = params[0];
            return `Date: ${moment(data[0]).format("DD MMM YYYY")}<br>Index:${data[1]}`;
          },
          backgroundColor: "#333",
          textStyle: {
            color: "#fff",
          },
        } :{
          trigger: "axis",
          formatter: (params) => {
            const { data } = params[0];
            return `Date: ${moment(data[0]).format("MMM YYYY")}<br>Index:${data[1]}`;
          },
          backgroundColor: "#333",
          textStyle: {
            color: "#fff",
          },

        },
        xAxis: {
          type: "time",
          name: "Date",
          nameLocation: "middle",
          nameGap: 30,
          nameTextStyle: {
            fontSize: 12,
            color: "#000000",
            fontWeight:'bold',
          },
          splitLine:{
            show:false,
          },

          axisLabel:  title.includes("Standardized Runoff Index")  ? {
            formatter: (value) => moment(value).format("DD MMM YYYY"),
            fontSize: 11,
        } : {
            formatter: (value) => moment(value).format(" MMM YYYY"),
            fontSize: 11,
          
        },
        
        //   axisTick: {
        //     alignWithLabel: true
        // },
          min: new Date(minimumDate).getTime(),
          max: new Date(maximumDate).getTime(),
        },
        yAxis: {
          type: "value",
          name: yAxisTitle,
          nameLocation: "middle",
          nameGap: 40,
          min: -2,
          max: 2,
          splitNumber: 3,
          nameTextStyle: {
            fontSize: 12,
            color: "#000000",
            fontWeight:"bold",

          },
       
          axisLabel: {
            formatter: (value) => value.toFixed(),
            fontSize: 11,
            
          },
        },
        series: [
          {
            type: "line",
            data: seriesData,
            smooth: true,
            symbol: "none",

            lineStyle: {
              width: 2,
              color: "#26a0fc",

            },
          },
        ],
        dataZoom: [
          // {
          //   type: "slider",
          //   xAxisIndex: 0,
          // },
          {
            type: "inside",
            xAxisIndex: 0,
          },
        ],
        toolbox: {
          feature: {
            magicType: {
              type: ["bar", "line"],
              title: {
                line: "Line Chart",
                bar: "Bar Chart",
              },
            },
            restore: {
              title: "Restore",
            },
            myMinimize: {
              show: true,
              title: "Minimize",
              icon: `image://${close}`,
              onclick: this.props.toggleVisibleGraphPanel,
            },
          },
          show: true,
          right: 10,
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "10%",
          containLabel: true,
        },
      },
    };
  }

  render() {
    return (
      <React.Fragment>
        <ReactECharts
          option={this.state.options}
          style={{ width: "100%",height:"400px"}}
        />
      </React.Fragment>
    );
  }
}

export default GradientChart;
